export const USER_UPDATE_RESET = "USER_UPDATE_RESET";
export const USER_UPDATE_SET_UPDATED = "USER_UPDATE_SET_UPDATED";
export const USER_UPDATE_SET_ERROR = "USER_UPDATE_SET_ERROR";
export const USER_UPDATE_TOGGLE_LOADING = "USER_UPDATE_TOGGLE_LOADING";
